import ProxyBase from '../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getNewsType(params) {
    return this.get('NewsType', params)
  }
  getSentiments(params) {
    return this.get('Sentiments', params)
  }
}

const proxy = new Proxy('News/')
export default proxy
